// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__AxBb1","errors":"Errors_errors__3lRMW"};